import request from '@/request';

/**
 * 获取验证码信息
 */
export function getKaptchaData() {
  return request({
    url: '/security/kaptcha.data'
  })
}


// WEBPACK FOOTER //
// ./src/components/Kaptcha/api.js